import logo from "./logo.png";
import logo01 from "./logo01.png"
import collection1 from "./img1.jpg";
import collection2 from "./img2.jpg";
import collection3 from "./img3.jpg";
import collection4 from "./img4.jpg";


import banner1 from "./banner1.png";
import banner2 from "./banner2.png";
import banner3 from "./banner3.png";
import banner4 from "./banner4.png";

import offer_banner from "./offerbanner1.png";

import ads_video from "./grainly_ad01.mp4";

import errorPage from "./errorpage.png";

const assets = {
    logo,
    logo01,
    collection1,
    collection2,
    collection3,
    collection4,
    banner1,
    banner2,
    banner3,
    banner4,
    offer_banner,
    ads_video,
    errorPage
}

export default assets;